import React, { useRef, useEffect } from 'react';
import noop from '../../utils/noop';
import * as styles from './container.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Container = _ref => {
  var _ref$showModal = _ref.showModal,
    showModal = _ref$showModal === void 0 ? false : _ref$showModal,
    children = _ref.children,
    _ref$onHide = _ref.onHide,
    onHide = _ref$onHide === void 0 ? noop : _ref$onHide,
    _ref$onShow = _ref.onShow,
    onShow = _ref$onShow === void 0 ? noop : _ref$onShow,
    appearance = _ref.appearance,
    width = _ref.width,
    height = _ref.height,
    maxWidth = _ref.maxWidth,
    maxHeight = _ref.maxHeight,
    minWidth = _ref.minWidth,
    minHeight = _ref.minHeight,
    fitContent = _ref.fitContent,
    allowOverflow = _ref.allowOverflow;
  var ref = useRef(null);
  useEffect(() => {
    var listener = evt => {
      if (evt instanceof TransitionEvent && evt.target === evt.currentTarget && (evt.propertyName === 'transform' || evt.propertyName === 'opacity')) {
        if (showModal) {
          onShow();
        } else {
          onHide();
        }
      }
    };
    var divRef = ref.current;
    divRef === null || divRef === void 0 ? void 0 : divRef.addEventListener('transitionend', listener);
    return () => divRef === null || divRef === void 0 ? void 0 : divRef.removeEventListener('transitionend', listener);
  }, [showModal, onShow, onHide]);
  return ___EmotionJSX("div", {
    ref: ref,
    css: styles.container({
      showModal,
      appearance,
      width,
      height,
      maxWidth,
      maxHeight,
      minWidth,
      minHeight,
      fitContent,
      allowOverflow
    })
  }, children);
};
export default Container;